import { NODE_FIELD_BOX } from "./nodeStyles";
export default function NodeInfoField(props: {
  label: string;
  value: string;
  action?: JSX.Element;
}) {
  return (
    <div
      className={
        "flex flex-col noDrag nowheel " +
        (props.label ? "gap-[8px]" : "")
      }
    >
      {props.label && (
        <div className="font-medium text-creator-text-sub text-[14px]">
          {props.label}
        </div>
      )}
      <div className={NODE_FIELD_BOX + " border-creator-border"}>
        <div className="flex min-w-0 flex-1 items-center h-full pl-[8px] pr-[2px] gap-[10px] text-creator-text-sub text-[20px]">
          <div className="my-auto min-w-0 flex-1 font-normal truncate text-[13px] text-creator-text">
            {props.value}
          </div>
          {props.action}
        </div>
      </div>
    </div>
  );
}
